<template>
  <div>
    <v-card class="elevation-0 ">
      <v-card-title >
        <span class="pink--text font-weight-bold ">Location Details</span>

        <v-spacer></v-spacer>
        <span  style="cursor: pointer;text-decoration: underline;"class="primary--text caption"
          @click="$emit('ShowEdit')">
          Edit <v-icon small>mdi-chevron-right</v-icon> </span>
      </v-card-title>
      <v-divider class=""></v-divider>
      <v-row  no-gutters>
        <v-col lg="6" sm="6" md="6" cols="12">
          <v-row no-gutters>
            <v-col>
              <v-row no-gutters>
                <v-col class="text-subtitle-2 text--disabled text-start " lg="6" sm="6" md="6" cols="6">
                  State Of Residence
                </v-col>
                <v-col class="text-subtitle-2 text-start font-weight-Normal" lg="6" sm="6" md="6" cols="6">
                  {{partnerpreference?.state}}
                  <!-- {{ $store.getters.handleEmptyString(userProfile.stateofResidence) }}  -->
<!-- {{  checkprofileCompleted(userProfile.stateofResidence,profileDetails?.stateofResidence,clientprofile) }} -->

                </v-col>
                <v-col class="text-subtitle-2 text--disabled text-start " lg="6" sm="6" md="6" cols="6">
                  City Of Residence
                </v-col>
                <v-col class="text-subtitle-2 text-start font-weight-Normal" lg="6" sm="6" md="6" cols="6">
                  {{partnerpreference?.district}}

                  <!-- {{ $store.getters.handleEmptyString(userProfile.cityofResidence) }}  -->
<!-- {{  checkprofileCompleted(userProfile.cityofResidence,profileDetails?.cityofResidence,clientprofile) }} -->

                </v-col>
                <v-col class="text-subtitle-2 text--disabled text-start " lg="6" sm="6" md="6" cols="6">
                    Residency Status
                </v-col>
                <v-col class="text-subtitle-2 text-start font-weight-Normal" lg="6" sm="6" md="6" cols="6">
                  {{partnerpreference?.country}}

                  <!-- {{ $store.getters.handleEmptyString(userProfile.residencyStatus) }}  -->
<!-- {{  checkprofileCompleted(userProfile.residencyStatus,profileDetails?.residencyStatus,clientprofile) }} -->

                </v-col>

              </v-row>

            </v-col>
          </v-row>
        </v-col>
         
       
      </v-row>
    </v-card>
    <v-divider class="mt-1"></v-divider>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // Your data here
    };
  },
  props:{
       partnerpreference:{}
    }
};
</script>

<style>
/* .info-text {
  font-size: 16px;
  color: #333;
  font-weight: 600;
} */

 .highlighted-divider {
  border: 2px solid #ff6061;
  /* Highlight color */
} 

/* .v-card-title {
  background-color: #f6bbd0;
  padding: 16px;
  border-radius: 6px;
} */

/* .pa-6 {
  padding: 16px !important;
} */

/* .elevation-2 {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
} */
</style>